import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { ApiService } from '../../services/api.service';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '../../common/models/common.model';
import { PurchaseOrder } from '../purchased-order.model';
import { buildFilterQuery, buildHttpParams } from '../../utils';

@Injectable({
  providedIn: 'root',
})
export class PurchasedOrderService {
  private readonly baseUrl = 'raw-materials/purchase-orders/';

  constructor(private apiService: ApiService) {}

  public list(q = {}): Observable<PaginatedResponse<PurchaseOrder>> {
    const params = buildHttpParams(q);
    return this.apiService.get(this.baseUrl, params);
  }

  public post(reqBody: any): Observable<PurchaseOrder> {
    return this.apiService.post(this.baseUrl, reqBody);
  }

  public delete(id: string): Observable<void> {
    return this.apiService.delete(this.baseUrl + `${id}/`);
  }

  public patch(id: string, reqBody: any): Observable<PurchaseOrder> {
    return this.apiService.patch(this.baseUrl + `${id}/`, reqBody);
  }

  public create_purchased_order_entry(id: string, reqBody: any): Observable<any> {
    return this.apiService.post(this.baseUrl + `${id}/fulfill/`, reqBody);
  }

  public update_purchased_order_entry(id: string, reqBody: any): Observable<any> {
    return this.apiService.put(this.baseUrl + `${id}/update_fulfillment/`, reqBody);
  }

  /**
   * Unpaginated export — never pass the list's page params. Observes the full
   * response so the Content-Disposition filename and a JSON error body are readable.
   */
  public export_purchase_orders(
    filters: {
      company?: string | null;
      supplier?: string | null;
      warehouse?: string | null;
      payment_status?: string | null;
      approval_status?: string | null;
      search?: string | null;
    } = {}
  ): Observable<HttpResponse<Blob>> {
    const params = buildHttpParams(buildFilterQuery(filters));

    return this.apiService.getBlobResponse(this.baseUrl + 'export-purchase-orders/', params);
  }
}
